<template>
  <v-snackbar
    v-model="snackbar"
    color="accent darken-1"
    vertical
    :timeout="-1"
    class="jcdc-confirm"
    multi-line
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="d-flex justify-center flex-column">
      <div class="white--text text-center" style="white-space: pre-line">
        {{ message }}
      </div>
      <div class="d-flex justify-center mt-3">
        <jcdc-btn
          color="white"
          secondary
          x-small
          align="right"
          @click="_cancel"
        >
          {{ cancelButton }}
        </jcdc-btn>
        <jcdc-btn x-small align="right" @click="_confirm">
          {{ okButton }}
        </jcdc-btn>
      </div>
    </div>
  </v-snackbar>
</template>
<script>
import JcdcBtn from '@/components/jcdc/JcdcBtn'
import { VSnackbar } from 'vuetify/lib'

export default {
  name: 'JcdcFlashMessage',
  components: { JcdcBtn, VSnackbar },
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      snackbar: this.value,
      message: undefined,
      okButton: 'Ok',
      cancelButton: 'Cancel',
      // Private variables
      resolvePromise: undefined,
      rejectPromise: undefined,
    }
  },
  methods: {
    show(opts = {}) {
      this.message = opts.message
      this.okButton = opts.okButton
      this.cancelButton = opts.cancelButton
      // Once we set our config, we tell the popup modal to open
      this.snackbar = true
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    _confirm() {
      this.snackbar = false
      this.resolvePromise(true)
    },
    _cancel() {
      this.snackbar = false
      this.resolvePromise(false)
    },
  },
}
</script>

<style lang="scss">
.v-snack.jcdc-confirm {
  .v-snack__content {
    margin: auto;
    padding: 16px 16px 8px;
    width: 100%;
  }
}
</style>
